export default {"src":"/_next/static/media/personLight.8b47273a.svg","height":19,"width":16};